module.exports = __webpack_public_path__ + "img/STERiGLIDE_02_03.3885935e.jpg";